module.exports = __webpack_public_path__ + "static/img/company31.cfb82b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/company31.png
// module id = A7WV
// module chunks = 0